import css from 'styled-jsx/css';

const styles = css.global`.rotoql-player-injury-status{background-color:#ff4f4d;font-weight:bold;font-size:13px;border-radius:10.5px;color:#efeff0;text-align:center;padding:2px 5px 2px 5px}`;

export default styles;